var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"command-bar-display"},[_c('div',{staticClass:"text-cursor-indicator"}),_c('div',{staticClass:"command-wrapper"},[_c('v-icon',{staticClass:"pr-1"},[_vm._v(" mdi-bank-outline ")]),_c('span',[_vm._v(_vm._s(_vm.command))])],1),_c('CommandBarDispalySvg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }